import React, { useState } from 'react';
import {
  Button,
  MenuItem,
} from '@material-ui/core';
import TranslateIcon from '@material-ui/icons/Translate';
import ExpandMoreIcon from '@material-ui/icons/ExpandMore';
import StyledHelpMenu from "@icarius-common/styledMenu";
import { getLocalizedString } from '@icarius-localization/strings';

const LanguageInput = ({ handleClick }) => {
  const [anchorEl, setAnchorEl] = useState(null);

  const handleMenuClick = (event) => {
    setAnchorEl(event.currentTarget);
  }

  const handleMenuClose = () => {
    setAnchorEl(null);
  }

  const onClick = (value) => {
    handleClick(value);
    handleMenuClose();
  }

  return (
    <>
      <Button
        style={{ marginBottom: 5 }}
        startIcon={<TranslateIcon />}
        endIcon={<ExpandMoreIcon />}
        onClick={handleMenuClick}
      >
        {getLocalizedString("changeLanguage")}
      </Button>
      <StyledHelpMenu
        anchorEl={anchorEl}
        isOpen={Boolean(anchorEl)}
        onClose={handleMenuClose}
        center
      >
        {
          [
            {
              key: "es",
              value: getLocalizedString("spanish"),
            },
            {
              key: "en",
              value: getLocalizedString("english"),
            },
          ].map((item) => {
            return (
              <MenuItem
                className={"whiteText"}
                key={item.key}
                value={item.key}
                onClick={() => onClick(item.key)}
              >
                {item.value}
              </MenuItem>
            )
          })
        }
      </StyledHelpMenu>
    </>
  );
}

export default LanguageInput;